import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-faq',
  templateUrl: './footer-faq.component.html',
  styleUrls: ['./footer-faq.component.scss']
})
export class FooterFaqComponent {
    //#region Public Variables
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    //#endregion Constructor

    //#region Public Methods
    //#endregion Public Methods
}
